import { render } from "./foldText.vue?vue&type=template&id=b048c168&scoped=true"
import script from "./foldText.vue?vue&type=script&lang=js"
export * from "./foldText.vue?vue&type=script&lang=js"

import "./foldText.vue?vue&type=style&index=0&id=b048c168&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b048c168"]])

export default __exports__